/* ============================================================
   pokesite — peluches catalogue logic
   ============================================================ */

const QInit = new URLSearchParams(location.search).get("q") || "";

const PALETTE_BG = ['var(--blue)','var(--yellow)','var(--green)','var(--pink)','var(--lilac)','var(--orange)','var(--cream-2)','var(--red)'];

function buildPlushList() {
  const list = [];
  POKE.FEATURED_PLUSHES.forEach((pid, idx) => {
    const p = POKE.GEN1.find(x => x.id === pid);
    if (!p) return;
    POKE.PLUSH_SIZES.forEach((sz, si) => {
      // skip some combos to vary inventory
      if ((pid * 7 + si) % 5 === 0) return;
      POKE.PLUSH_COLLECTIONS.forEach((col, ci) => {
        if (((pid * 11) + si + ci * 3) % 4 === 0) return;
        const basePrice = 22 + ((pid % 5) * 2);
        const price = basePrice + sz.modifier + col.modifier;
        list.push({
          id: `${pid}-plush-${sz.id}-${col.id}`,
          pid: p.id,
          name: p.name,
          sprite: p.sprite,
          img: p.img,
          size: sz.id,
          sizeLabel: sz.label,
          collection: col.id,
          collectionLabel: col.label,
          price,
          bg: PALETTE_BG[(pid + si + ci) % PALETTE_BG.length],
          featured: idx < 10,
        });
      });
    });
  });
  return list;
}

const ALL_PLUSH = buildPlushList();

const PSTATE = {
  q: QInit,
  size: "all",
  col: "all",
  sort: "featured",
};

document.addEventListener("DOMContentLoaded", () => {
  const search = document.getElementById("plush-search");
  search.value = QInit;
  search.addEventListener("input", e => { PSTATE.q = e.target.value; render(); });
  document.getElementById("plush-sort").onchange = e => { PSTATE.sort = e.target.value; render(); };
  document.querySelectorAll("#size-seg button").forEach(b => b.onclick = () => {
    document.querySelectorAll("#size-seg button").forEach(x => x.classList.remove("on"));
    b.classList.add("on");
    PSTATE.size = b.dataset.size;
    render();
  });
  document.querySelectorAll("#col-seg button").forEach(b => b.onclick = () => {
    document.querySelectorAll("#col-seg button").forEach(x => x.classList.remove("on"));
    b.classList.add("on");
    PSTATE.col = b.dataset.col;
    render();
  });
  render();
});

function render() {
  let list = ALL_PLUSH.slice();
  if (PSTATE.q.trim()) {
    const q = PSTATE.q.trim().toLowerCase();
    list = list.filter(p => p.name.toLowerCase().includes(q));
  }
  if (PSTATE.size !== "all") list = list.filter(p => p.size === PSTATE.size);
  if (PSTATE.col !== "all")  list = list.filter(p => p.collection === PSTATE.col);

  switch (PSTATE.sort) {
    case "price-asc":  list.sort((a,b) => a.price - b.price); break;
    case "price-desc": list.sort((a,b) => b.price - a.price); break;
    case "size-asc":   list.sort((a,b) => +a.size - +b.size); break;
    default:           list.sort((a,b) => (b.featured?1:0) - (a.featured?1:0));
  }

  document.getElementById("plush-stats").innerHTML = `
    <span><strong style="color:var(--ink);">${list.length}</strong> peluches</span>
    <span>Tailles ${PSTATE.size === 'all' ? '8 / 20 / 30 / 50 cm' : PSTATE.size + ' cm'}</span>
    <span>Collection ${PSTATE.col === 'all' ? 'toutes' : POKE.PLUSH_COLLECTIONS.find(c=>c.id===PSTATE.col).label}</span>
  `;

  const root = document.getElementById("plush-grid");
  root.innerHTML = list.map(p => `
    <div class="plush-card">
      <div class="plush-media" style="background: ${p.bg};">
        <image-slot id="plush-${p.id}" shape="rect" placeholder="${p.name} ${p.sizeLabel}"></image-slot>
        <span class="plush-size-badge">${p.sizeLabel.replace(' ', ' ')}</span>
        <button class="plush-fav" data-fav aria-label="Favori">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1A5.5 5.5 0 0 0 3.1 12.5l8 8a1 1 0 0 0 1.4 0l8.3-8.2a5.5 5.5 0 0 0 0-7.8Z"/></svg>
        </button>
      </div>
      <div class="plush-info">
        <div class="plush-collection">${p.collectionLabel}</div>
        <div class="plush-name">${p.name} · ${p.sizeLabel}</div>
        <div class="plush-row">
          <div class="plush-price">${p.price.toFixed(2).replace('.', ',')} €</div>
          <button class="plush-add" data-add='${p.id}'>+</button>
        </div>
      </div>
    </div>
  `).join("");

  root.querySelectorAll("[data-add]").forEach(b => b.onclick = () => {
    const id = b.dataset.add;
    const item = ALL_PLUSH.find(x => x.id === id);
    if (!item) return;
    Cart.add({
      id: item.id,
      name: item.name,
      price: item.price,
      variant: `Peluche ${item.sizeLabel} · ${item.collectionLabel}`,
      image: item.sprite,
      bg: item.bg,
      qty: 1,
    });
    b.textContent = "✓";
    setTimeout(() => { b.textContent = "+"; }, 900);
  });
  root.querySelectorAll("[data-fav]").forEach(b => b.onclick = () => b.classList.toggle("on"));
}
